export default __webpack_public_path__ + "static/media/MarkLukas.90ca6466.jpg";